<template>
  <div class="volumes-multiple">
    <el-dialog
      @close="closeDialog"
      title="Распределить"
      :visible.sync="openDialog"
      width="30%"
      center
    >
      <date-picker
        v-if="index !== null"
        ref="datePicker"
        :editable="false"
        :disabled-date="disabledRange"
        placeholder="Фильтр по дате"
        v-model="datetimeRangeDownload"
        range
      ></date-picker>
      <el-form>
        <el-checkbox v-model="weekend[6]" style="margin-top: 10px">Суббота</el-checkbox>
        <el-checkbox v-model="weekend[0]" style="margin-top: 10px">Воскресенье</el-checkbox>

        <div v-if="index === null" class="turn">
          <el-checkbox v-model="turn[1]" style="margin-top: 10px">Смена 1</el-checkbox>
          <el-checkbox v-model="turn[2]" style="margin-top: 10px">Смена 2</el-checkbox>
          <el-checkbox v-model="turn[3]" style="margin-top: 10px">Смена 3</el-checkbox>

        </div>

        <el-form-item :label="`Смена ${index}`" v-if="index !== null">
          <el-input v-model="inputValue"
          ></el-input>
        </el-form-item>
        <el-checkbox v-if="index !== null" v-model="byDate" style="margin-top: 10px">По датам</el-checkbox>

      </el-form>
      <el-button style="margin-top: 20px" type="primary" @click="save">Применить</el-button>
    </el-dialog>
    <div @click="openDialog = true">
      <slot>
        <i class="fa fa-edit" @click="openDialog = true"></i>
      </slot>
    </div>
  </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import dayjs from "dayjs";
import {getAllDates} from "../../../../utils/date";
import {BigNumber} from 'bignumber.js';
import {toFixedWithoutZero} from "../../../../utils/numberUtils";

export default {
  name: "VolumeMultiple",
  props: {
    index: {
      type: [Number, Object],
      default: null
    },
    name: String,
    currentMonth: Number,
    planRow: [Object, Array],
    type: String,
    propsValue: Number
  },
  components: {DatePicker},
  data() {
    return {
      openDialog: false,
      datetimeRangeDownload: [
        null,
        null,
      ],
      turn: {
        1: true,
        2: false,
        3: false
      },
      inputValue: '',
      byDate: false,
      weekend: {
        0: true,
        6: true
      }
    }
  },
  watch: {
    openDialog(k) {
      if (this.openDialog) {
        const name = this.$route.query.name;
        const year = name.split('-')[1]
        this.datetimeRangeDownload = [
          new Date(String(dayjs(new Date(year, this.currentMonth - 1, 1)).format('YYYY-MM-DD'))),
          new Date(String(dayjs(new Date(year, this.currentMonth - 1, dayjs(new Date(year, this.currentMonth - 1, 1)).daysInMonth())).format('YYYY-MM-DD'))),
        ]
      }
    },
    propsValue() {
      this.inputValue = this.propsValue
    }
  },
  mounted() {
    this.inputValue = this.propsValue
  },
  methods: {
    disabledRange: function (date) {
      const name = this.$route.query.name;
      const year = name.split('-')[1]
      return date < new Date(year, this.currentMonth - 1, 1) || date > new Date(year, this.currentMonth - 1, dayjs(new Date(year, this.currentMonth - 1, 1)).daysInMonth());
    },
    closeDialog() {
      this.openDialog = false
    },
    save() {
      const ranges = getAllDates(dayjs(this.datetimeRangeDownload[0]).format('YYYY.MM.DD'), dayjs(this.datetimeRangeDownload[1]).format('YYYY.MM.DD'));
      const plan = this.index !== null ? {...this.planRow} : [...this.planRow]
      const without_weekend = []
      ranges.forEach((d) => {
        let day = new Date(d).getDay();
        if (day === 6 && !this.weekend[6] || day === 0 && !this.weekend[0]) {
          return
        }
        without_weekend.push(d)
      });

      if (this.index !== null) {
        without_weekend.forEach((d) => {
          const key = dayjs(d).format('DD.MM.YYYY');
          if (!this.byDate) {
            plan[key] = new BigNumber(String(this.inputValue)
              .replace(',', '.'))
              .div(without_weekend.length).toNumber()
          } else {
            plan[key] = this.inputValue
          }
        })

        this.$emit('apply', plan)
      } else {
        const turnActive = []
        Object.entries(this.turn).forEach(([k, v]) => {
          if(v) {
            turnActive.push(k)
          }
        })

        turnActive.map((p) => {
          without_weekend.forEach((d) => {
            const key = dayjs(d).format('DD.MM.YYYY');
            if (!this.byDate) {
              if(this.type === 'JOB') {
                plan[p][key] = toFixedWithoutZero(new BigNumber(String(this.inputValue)
                  .replace(',', '.'))
                  .div(without_weekend.length).div(turnActive.length || 1).toNumber())
              } else {
                plan[p][key] = toFixedWithoutZero(new BigNumber(String(this.inputValue)
                  .replace(',', '.'))
                  .div(turnActive.length || 1).toNumber())

                plan[p].all = toFixedWithoutZero(new BigNumber(String(this.inputValue)
                  .replace(',', '.'))
                  .div(turnActive.length || 1).toNumber())
              }
            } else {
              plan[p][key] = this.inputValue
            }
          });
        });


        this.$emit('applyForAll', plan)
      }

      this.closeDialog()
    }
  }
}
</script>
<style lang="scss" scoped>
.turn {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  border-top: 1px solid #e8e8e8;
  padding-top: 5px
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Jobs/components/VolumeMultiple.vue